/** Reminders to a supervisor: when one may be sent again, and how long ago the last went out. */
export const COOLDOWN_MS = 24 * 60 * 60 * 1000; // the proxy's own limit (referenceLetterPing.js)

/** Sent less than a day ago: the proxy would refuse another. */
export const remindedRecently = (pingedAt: string | null, now = Date.now()) =>
  Boolean(pingedAt) && now - Date.parse(pingedAt as string) < COOLDOWN_MS;

/** Milliseconds until another reminder is allowed; null when one is allowed now (or never sent). */
export function reminderOpensIn(pingedAt: string | null, now = Date.now()) {
  if (!remindedRecently(pingedAt, now)) return null;
  return Date.parse(pingedAt as string) + COOLDOWN_MS - now;
}

/** "Reminded today", "Reminded yesterday", "Reminded 3 days ago" — whole calendar days, local time; null for a non-date. */
export function remindedLabel(pingedAt: string, now = new Date()) {
  if (Number.isNaN(Date.parse(pingedAt))) return null;
  /** A local calendar day as a number, so days subtract cleanly across daylight saving. */
  const day = (d: Date) => Date.UTC(d.getFullYear(), d.getMonth(), d.getDate());
  const days = Math.round((day(now) - day(new Date(pingedAt))) / 86_400_000);
  if (days <= 0) return 'Reminded today';
  if (days === 1) return 'Reminded yesterday';
  return `Reminded ${days} days ago`;
}

/** When the next reminder is allowed, as local "HH:MM" (today or tomorrow is plain from the label). */
export function nextReminderTime(pingedAt: string) {
  return new Date(Date.parse(pingedAt) + COOLDOWN_MS).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
}
